import { QuarterSelectorType } from '@cbre/components';

const updatePeriodValue = (
  periodType: QuarterSelectorType,
  periodYear: number,
  periodQtrMon: number,
  maxYear: number,
  today: Date
) => {
  if (periodType === QuarterSelectorType.Quarter) {
    // if periodQtrMon is not null, it means that the value is the from month else from year
    if (periodQtrMon) {
      return Math.ceil(periodQtrMon / 3);
    }
    return periodYear === maxYear ? Math.ceil((today.getMonth() + 1) / 3) : 4;
  }
  if (periodType === QuarterSelectorType.Monthly) {
    // if periodQtrMon is null, it means that the value is the from quarter  else from year
    if (periodQtrMon) {
      const curMonth = today.getMonth() + 1;
      // if the periodQtrMon * 3 is greater than the current month, then return the current month
      return periodYear === maxYear && periodQtrMon * 3 > curMonth ? curMonth : periodQtrMon * 3;
    }
    return periodYear === maxYear ? today.getMonth() + 1 : 12;
  }
  return null;
};

const updatePeriodYear = (periodType: QuarterSelectorType, periodYear: number, maxYear: number) => {
  if (periodType === QuarterSelectorType.Yearly && periodYear > maxYear) {
    return maxYear;
  }
  return periodYear;
};

export const updateValues = (
  val: any,
  periodType: QuarterSelectorType.Yearly,
  maxYear: number,
  today: Date,
  changedFromYear: boolean
) => {
  if (val) {
    val.periodYear = updatePeriodYear(periodType, val.periodYear, maxYear);
    val.periodValue = updatePeriodValue(
      periodType,
      val.periodYear,
      changedFromYear ? null : val.periodValue,
      maxYear,
      today
    );
  }
};
